import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-tea-50 flex items-center justify-center">
      <div className="text-center">
        <div className="text-9xl font-extrabold text-tea-200 mb-4">404</div>
        <h1 className="text-3xl font-bold mb-2">Page Not Found</h1>
        <p className="text-gray-500 mb-8">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link to="/" className="btn-primary">Go Home</Link>
      </div>
    </div>
  );
}
